import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter, Link, Router, useLocation } from 'react-router-dom'
import gamefilter from "../../dataset/gamefilter.json";
import Carousel from "react-multi-carousel";
import { useTranslation } from 'react-i18next';

import './BottomNav.css'
function BottomNav() {
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation

  const [isMobile, setIsMobile] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const filters = gamefilter


  return (

    <div className="-outer-wrapper">
      <div className="-left-wrapper">
        <span className="-item-wrapper"
        ><span className="-ic-img text-center"
        >
            <a href={process.env.REACT_APP_LOGIN}>
              <img
                loading="lazy"
                width={30}
                src="https://reno69.bet/assets/ez/images/nav-menu-bottom/nav-menu-login.svg"
                className="image wp-image-1579 attachment-full size-full"
                alt=""
                style={{ maxWidth: "100%", height: 'auto' }}
                decoding="async"
              /></a></span>    <span className='nav-text'>เข้าสู่ระบบ</span></span><span className="-item-wrapper"
              ><span className="-ic-img text-center"
              ><a

                href={process.env.REACT_APP_REGISTER}>
              <img
                loading="lazy"
                width={30}
                src="https://reno69.bet/assets/ez/images/nav-menu-bottom/nav-menu-register.svg"
                className="image wp-image-1580 attachment-full size-full"
                alt=""
                style={{ maxWidth: "100%", height: 'auto' }}
                decoding="async"
              /></a></span>    <span className='nav-text'>สมัคร</span></span>
      </div>
      <span
        className="-center-wrapper js-footer-lobby-selector js-menu-mobile-container"
      >
        <div className="-selected">
          <a href={process.env.REACT_APP_URL}>
            <img
              src={require("../../assets/RN69.png")}
              alt="RN69"
              style={{ maxWidth: "100%", height: 'auto' }}

            />
          </a>
        </div>
      </span>
      <div className="-fake-center-bg-wrapper">
        <svg viewBox="-10 -1 30 12">
          <defs>
            <linearGradient
              id="rectangleGradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop offset="0%" stop-color="#4695fc"></stop>
              <stop offset="100%" stop-color="#081e99"></stop>
            </linearGradient>
          </defs>
          <path
            d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"
          ></path>
        </svg>
      </div>
      <div className="-right-wrapper">
        <span className="-item-wrapper"
        ><span className="-ic-img text-center"
        ><a href={process.env.REACT_APP_URL}
        ><img
                loading="lazy"
                width={40}
                src="https://reno69.bet/assets/ez/images/nav-menu-bottom/nav-menu-promotion.svg"
                className="image wp-image-1577 attachment-full size-full"
                alt=""
                style={{ maxWidth: "100%", height: 'auto' }}
                decoding="async"
              /></a></span>
          <span className='nav-text'>โปรโมชั่น</span>
        </span><span className="-item-wrapper"
        ><span className="-ic-img text-center"
        ><a href={process.env.REACT_APP_LINE}
        ><img
                loading="lazy"
                width={30}
                src="https://reno69.bet/assets/ez/images/nav-menu-bottom/nav-menu-support.svg"
                className="image wp-image-1578 attachment-full size-full"
                alt=""
                style={{ maxWidth: "100%", height: 'auto' }}
                decoding="async"

              /></a></span><span className='nav-text'>ติดต่อ</span></span>

      </div>
      <div className="-fully-overlay js-footer-lobby-overlay"></div>
    </div>


  )
}

export default BottomNav